module.exports = __webpack_public_path__ + "static/media/paypal.40fe7d84.jpeg";